import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "userScan" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12 10.2866C12.5683 10.2866 13.1133 10.0608 13.5152 9.65888C13.9171 9.25693 14.1428 8.71177 14.1428 8.14332C14.1428 7.57488 13.9171 7.02972 13.5152 6.62777C13.1133 6.22581 12.5683 6 12 6C11.4317 6 10.8866 6.22581 10.4848 6.62777C10.0829 7.02972 9.85713 7.57488 9.85713 8.14332C9.85713 8.71177 10.0829 9.25693 10.4848 9.65888C10.8866 10.0608 11.4317 10.2866 12 10.2866V10.2866ZM7 16.7166C7 16.0599 7.12933 15.4095 7.3806 14.8028C7.63187 14.196 8.00017 13.6447 8.46446 13.1803C8.92875 12.7159 9.47995 12.3475 10.0866 12.0962C10.6932 11.8449 11.3434 11.7155 12 11.7155C12.6566 11.7155 13.3068 11.8449 13.9134 12.0962C14.52 12.3475 15.0712 12.7159 15.5355 13.1803C15.9998 13.6447 16.3681 14.196 16.6194 14.8028C16.8706 15.4095 17 16.0599 17 16.7166H7Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Stroke",
    d: "M21 17V17.8C21 18.9201 21 19.4802 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H17M21 7V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3H17M7 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.0799 3 6.2V7M3 17V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21H7",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }